import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  standalone: true,
})
export class FooterComponent {
  public year = new Date().getFullYear();
  @Input() bgClass = 'bg-dark'
  @Input() isComing = false
  @Input() textClass = 'text-white'
}
